import styled from "styled-components";


interface FlexProps {
  flexDir?: string
  gap?: string
  padding?: string
  margin?: string
  justifyContent?: string
  alignItems?: string
  height?: string
  width?: string
  position?: string
  top?: string;
  bottom?: string;
  right?: string;
  left?: string;
  bgColor?: string;
  zIndex?: string;
  alignSelf?: string;
}

interface TextProps {
  fontSize?: string;
  fontWeight?: string;
  color?: any;
  width?: string;
  height?: string;
  align?: string;
  display?: string;
  justify?: string;
  margin?: string;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2.5rem 3rem;

  .sticky-button {
  }
` 

export const Flex = styled.div<FlexProps>`
  display: flex;
  height: ${props => props.height};
  width: ${props => props.width};
  align-items: ${props => props.alignItems ? props.alignItems : ""};
  justify-content: ${props => props.justifyContent ? props.justifyContent : ""};
  flex-direction: ${props => props.flexDir ? props.flexDir : "row"};
  padding: ${props => props.padding ? props.padding : "0"};
  gap: ${props => props.gap ? props.gap : "2rem"};
  position: ${props => props.position ? props.position : ""};
  top: ${props => props.top ? props.top : ""};
  left: ${props => props.left ? props.left : ""};
  right: ${props => props.right ? props.right : ""};
  bottom: ${props => props.bottom ? props.bottom : ""};
  background-color: ${props => props.bgColor ? props.bgColor : ""};
  z-index: ${props => props.zIndex ? props.zIndex : ""};
  align-self: ${props => props.alignSelf ? props.alignSelf : ""};
`

export const Image = styled.img`
  width: 50px;
`

export const Text = styled.span<TextProps>`
  display: ${props => props.display ? props.display : ""};
  align-items: ${props => props.align ? props.align : ""};
  justify-content: ${props => props.justify ? props.justify : ""};
  font-size: ${props => props.fontSize ? props.fontSize : "16px"};
  font-weight: ${props => props.fontWeight ? props.fontWeight : "400"};
  color: ${props => props.color ? props.color : "var(--gray-600)"};
  width: ${props => props.width ? props.width : ""};
  height: ${props => props.height ? props.height : ""};
  margin: ${props => props.margin ? props.margin : ""};
`

export const Header = styled.h1<TextProps>`
  font-size: ${props => props.fontSize ? props.fontSize : "25px"};
  font-weight: ${props => props.fontWeight ? props.fontWeight : "400"};
  color: ${props => props.color ? props.color : "var(--gray-800)"};
`

export const Badge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #DBF0F4;
  border-radius: 4px;
  height: 40px;
  width: 40px;
`